module.exports = __webpack_public_path__ + "epdf-app/principal/container/container-details-2lVYTh9v.html";